import styles from './styles.module.scss';

export const Cover = () => (
  <>
    <div className={styles.cover_img} />
    <div className={styles.cover_bg} />
  </>
);
